import { render, staticRenderFns } from "./BannerNotifications.vue?vue&type=template&id=db6b38d2&scoped=true&"
import script from "./BannerNotifications.vue?vue&type=script&lang=ts&"
export * from "./BannerNotifications.vue?vue&type=script&lang=ts&"
import style0 from "./BannerNotifications.vue?vue&type=style&index=0&id=db6b38d2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db6b38d2",
  null
  
)

export default component.exports